/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
define(['jquery', './BidiUtil', './dnd/DnDManager', 'underscore', 'hammerjs', 'jquery.hammer'], function ($, BidiUtil, DnDManager, _, hammer) {

	// Setup jquery to create a hammer instance when we use hammer events.
	var hammerGestures = [];
	for (var name in hammer.gestures) {
		if (hammer.gestures.hasOwnProperty(name)) {
			hammerGestures.push(hammer.gestures[name].name);
		}
	}
	var hammerDefaultOptions = {
		'prevent_mouseevents': true,
		'stop_browser_behavior': false
	};
	$.each(hammerGestures, function (index, name) {
		$.event.special[name] = {
			setup: function setup() {
				var $el = $(this);
				var inst = $el.data('hammer');
				if (!inst) {
					// create hammer instance with default values
					$el.hammer(hammerDefaultOptions);
				}
			}
		};
	});

	/**
  * A jQuery function that can be used to attach the onClick event handler. This function will also attach the touch events required for touch devices to avoid the delay caused by simulated mouse
  * events
  */
	$.fn.onClick = function (handler) {
		this.on('click', function (e) {
			handler(e);
		}).on('tap', function (e) {
			handler(e);
			// prevent the simulated clicks on touch devices
			e.gesture.preventDefault();
		});
		return this;
	};

	// Get the box style to be applied to the inline editor
	var getInlineEditBoxStyles = function getInlineEditBoxStyles($text, options) {

		var cssProps = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'border-bottom-color', 'border-bottom-style', 'border-bottom-width', 'border-top-color', 'border-top-style', 'border-top-width', 'border-right-color', 'border-right-style', 'border-right-width', 'border-left-color', 'border-left-style', 'border-left-width', 'position', 'top', 'right', 'left', 'bottom', 'height', 'width', 'min-height', 'min-width', 'max-height', 'max-width'];

		var cssValues = $text.css(cssProps);

		// We don't want to set a zero height and width
		if (cssValues.height === '0px') {
			delete cssValues.height;
		}
		if (cssValues.width === '0px') {
			delete cssValues.width;
		}

		// Set the maximum width to strech with the parent
		if (options && options.maxSizeNode) {
			var $node = $(options.maxSizeNode);
			var width = options.maxSizeNode.style.width;
			if (width) {
				cssValues['max-width'] = '100%';
				delete cssValues.width;
			} else {
				cssValues['max-width'] = $node.width() + 'px';
			}
		}

		return cssValues;
	};

	// Get the css styles to be applied to the inline editor input element
	var getInlineEditStyles = function getInlineEditStyles($text) {

		var textCss = {
			width: '0px',
			'min-width': $text.css('fontSize')
		};

		// Get the text alignment and apply it to the text input
		var textAlignment = $text.css('text-align');
		if (textAlignment === 'center') {
			textCss['margin'] = '0px auto';
		} else if (textAlignment === 'right') {
			textCss['margin'] = '0px 0px 0px auto';
		}

		return textCss;
	};

	// Get the text css style to be applied to the inline editor
	var getInlineEditTextStyles = function getInlineEditTextStyles($text) {
		return $text.css(['fontSize', 'fontFamily', 'fontWeight', 'letterSpacing', 'color']);
	};

	var _addInlineEditHandlers = function _addInlineEditHandlers($text, fCallback, options) {

		var $inlineEdit = $text._$inlineEdit;

		$text._updateWidth = function () {
			if ($inlineEdit) {
				var value = $inlineEdit.val() || '';
				if (value !== $inlineEdit._hidden.text()) {
					$inlineEdit._hidden.text(value);
					$inlineEdit.width($inlineEdit._hidden.width() + 2);
				}
			}
		};

		$text._inlineEditChangedFn = function () {
			var sText = $inlineEdit.val().trim();

			if (sText.length === 0 && options.noEmptyText) {
				sText = $text._previousInlineText;
			}

			$inlineEdit.removeClass('inlineText').off('keypress').off('keydown').off('blur');
			var invokeCallback = false;
			if ($text._previousInlineText !== sText) {
				invokeCallback = true;
			}
			$text._previousInlineText = null;
			$inlineEdit._hidden.remove();
			$inlineEdit._hidden = null;
			$inlineEdit.off();
			$inlineEdit.hide();
			$inlineEdit.parent().remove();
			$inlineEdit = null;
			$text._$inlineEdit = null;

			$text.text(sText);
			$text.removeClass('inEditMode');
			$text.show().focus();

			if (invokeCallback) {
				fCallback(sText);
			}

			var onEditEnd = options && options.onEditEnd;
			if (onEditEnd) {
				onEditEnd();
			}
		}.bind($text);

		var sText = $text.text();
		$text._previousInlineText = sText; // keep a back up of the current string

		if (!$inlineEdit) {

			$text.addClass('inEditMode');

			// Create a container node that will inherit the text container properties
			// like margin, padding, border and position
			var $inlineEditContainer = $('<div>', {
				'class': 'inlineEditContainer'
			});
			$inlineEditContainer.css(getInlineEditBoxStyles($text, options));
			$text.after($inlineEditContainer);

			$inlineEdit = $('<input>', {
				'class': 'inlineText'
			});

			$inlineEdit.css('max-width', '100%');
			$inlineEdit.css(getInlineEditStyles($text));
			var cssValues = getInlineEditTextStyles($text);
			$inlineEdit.css(cssValues);

			$inlineEditContainer.append($inlineEdit);

			$text._$inlineEdit = $inlineEdit;
			$inlineEdit.val(sText);

			$inlineEdit._hidden = $('<div style="white-space:pre; top:-999px; left:-999px; position:absolute;"/>');
			$inlineEdit._hidden.css(cssValues);

			$text.hide();
			$text.after($inlineEdit._hidden);
			$inlineEdit.on('keyup keydown input propertychange change', function () {
				$text._updateWidth();
			});

			if (options && options.style) {
				$inlineEdit.css(options.style);
			}

			$text._updateWidth();

			$inlineEdit.on('blur', $text._inlineEditChangedFn).on('keypress', function (e) {
				if (e.keyCode === 13) {
					$text._inlineEditChangedFn();
				}
			}).on('keyup', function (e) {
				//stop propagation for delete key
				if (e.keyCode === 46 || e.keyCode === 8) {
					e.stopPropagation();
				}
			}).on('keydown', function (e) {
				// stop the arrow keys from bubbling when in edit mode. Fix for when editing the name of a tab.
				if (e.keyCode === 37 || e.keyCode === 39) {
					e.stopPropagation();
				}
			}).on('mousedown mouseup dblclick', function (e) {
				// cancel the mouse down, up and double click to allow the user to interact with the text
				e.stopPropagation();
			});
			BidiUtil.initElementForBidi($inlineEdit[0]);
			$inlineEdit.show();
		} else {
			$inlineEdit.val(sText);
		}

		$inlineEdit.focus();
		$inlineEdit[0].setSelectionRange(0, 9999); //needed for selecting on ios

		return false;
	};

	/**
  * Turns an div element into an inline edit control
  */
	$.fn.inlineEditor = function (action, options) {
		if (action === 'remove') {
			if (this._$inlineEdit) {
				this._inlineEditChangedFn();
			}

			this.off('dblclick', this._inlineEditFn);
			this.off('hold', this._inlineEditFn);
			delete this._inlineEditFn;
			delete this._previousInlineText;
			delete this._inlineEditChangedFn;
			delete this._updateWidth;
		} else if (action === 'blur') {

			if (this._$inlineEdit) {
				this._inlineEditChangedFn();
			}
		} else if (action === 'isEditing') {
			return this._$inlineEdit ? true : false;
		} else if (action === 'edit') {
			if (this._inlineEditFn) {
				this._inlineEditFn();
			}
		} else {
			var onEditStart = options && options.onEditStart;
			this._inlineEditFn = function (e) {

				DnDManager.resetDragging();

				if (onEditStart) {
					onEditStart();
				}
				_addInlineEditHandlers(this, action, options);

				if (e) {
					e.stopPropagation();
				}
			}.bind(this);
			this.hammer({
				stop_browser_behavior: false,
				prevent_mouseevents: true
			});
			this.on('dblclick', this._inlineEditFn);
			this.on('hold', this._inlineEditFn);
			this.on('keypress', function (e) {
				var keyCode = e.keyCode || e.charCode;
				if (keyCode === 13 || keyCode === 32) {
					this._inlineEditFn(e);
				}
			}.bind(this));
		}
	};
});
//# sourceMappingURL=EventHelper.js.map



// WEBPACK FOOTER //
// ./src/js/lib/@waca/core-client/js/core-client/utils/EventHelper.js